<template>
    <svg
        fill="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="m13.293 6.297-5.707 5.707 5.707 5.707 1.414-1.414-4.293-4.293 4.293-4.293-1.414-1.414Z"
        ></path>
    </svg>
</template>
